const shorthandBadgePaddingX = 6;
const shorthandBadgePaddingY = 4;
const shorthandBadgeFontSize = 10;

export const tokens = {
    padding: 24,
    height: 60,
    fontSize: 14,
    report: {
        gap: 4,
        labelSize: 12,
    },
    shorthand: {
        gap: 4,
        labelSize: 16,
        badge: {
            padding: shorthandBadgePaddingX,
            height: shorthandBadgePaddingY * 2 + shorthandBadgeFontSize,
            labelSize: shorthandBadgeFontSize,
        },
    },
    date: {
        labelSize: 16,
        iconSize: 20,
    },
    popover: {
        // This value is passed to `floating-ui`, so it has to remain a `px` value.
        offset: 10,
    },
    menu: {
        radius: 10,
        list: {
            gap: 2,
            padding: 4,
        },
        option: {
            gap: 8,
            radius: 6,
            padding: 8,
        },
        symbol: {
            size: 20,
            iconSize: 12,
        },
    },
};
